import React, { useMemo } from 'react';
import { observer } from "mobx-react";
import { Button, Stack } from "react-bootstrap";
import { SuspenseButton } from '@common/components/utility';

interface ICancelNextActionsProps {
    cancelText?: string
    nextText?: string,
    nextVisible?: boolean,
    cancelAction: () => void,
    nextAction?: () => void,
    tag?: string,
    isSubmit?: boolean
}


export const CancelNextActions = observer((props: ICancelNextActionsProps) => {

    const nextText = useMemo(() => props.nextText ? props.nextText : 'Next', [props.nextText]);
    const cancelText = useMemo(() => props.cancelText ? props.cancelText : 'Cancel', [props.cancelText])
    const defaultType = props.isSubmit ?? false;
    return (
        <Stack className="justify-content-end mt-4" direction="horizontal" gap={2}>
            <Button onClick={props.cancelAction} variant="light">{cancelText}</Button>
            <SuspenseButton hideSpinner={false} tag={props.tag} onClick={props.nextAction} type={defaultType ? "submit" : "button"} variant="primary">{nextText}</SuspenseButton>
        </Stack>
    );
});
